import usersApi, { UpdateUserSettingsPayload } from '@/api/identity/usersApi'
import { queryKeys } from '@/constant/common'
import { NotifyService } from '@/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const useUpdateUserSettings = () => {
  const queryClient = useQueryClient()

  const { mutate } = useMutation(
    (payload: UpdateUserSettingsPayload) => usersApi.updateSettings(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.user])
        queryClient.invalidateQueries([queryKeys.interface])
        window.location.reload()
      },
      onError: (error) => {
        console.error('Update user settings failed:', error)
        NotifyService.error(error)
      },
    },
  )

  return mutate
}

export default useUpdateUserSettings
